import { makeStyles, Typography } from "@material-ui/core";
import React, { useLayoutEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CartIcon } from "../../../components/customIcons";

const style = makeStyles((theme) => ({
	container: {
		position: "fixed",
		bottom: "200px",
		right: "50px",
		zIndex: -1,
	},
	textContainer: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		gap: "5px",
		right: "20px",
		opacity: "0.6",
	},
	icon: {
		color: theme.palette.primary.main,
		transform: "scale(4) rotate(-15deg)",
		opacity: 0.4,
	},
	text: {
		maxWidth: "150px",
		textAlign: "center",
		fontWeight: 900,
	},
}));

export function CartSuggestionIndicator(props) {
	const cartBehavior = useSelector((state) => state.cartBehavior);
	const [drawerHeight, setDrawerHeight] = useState<number>(200);
	const classes = style();

	// Change height based on the bottom drawer
	useLayoutEffect(() => {
		const mobile = document.querySelector("#cart-preview-drawer-mobile");
		const desktop = document.querySelector("#cart-preview-drawer-desktop");

		const el = mobile ?? desktop;
		if (!el) return;

		setDrawerHeight(el.clientHeight);

		const observer = new ResizeObserver((entries) => {
			for (const entry of entries) {
				setDrawerHeight(entry.target.clientHeight);
			}
		});
		observer.observe(el);

		return () => observer.disconnect();
	}, []);

	if (!cartBehavior.suggestionType) {
		return null;
	}

	if (cartBehavior.suggestionType === "icon") {
		return (
			<div
				className={classes.container}
				style={{
					bottom: drawerHeight ? drawerHeight + 40 : 200,
				}}
			>
				<CartIcon className={classes.icon} />
			</div>
		);
	}

	return (
		<div
			className={`${classes.container} ${classes.textContainer}`}
			style={{
				bottom: drawerHeight ? drawerHeight : 200,
			}}
		>
			<Typography
				variant="body2"
				color="primary"
				className={classes.text}
			>
				{cartBehavior.suggestionText}
			</Typography>
			<Arrow />
		</div>
	);
}

function Arrow() {
	return (
		<svg
			width="54"
			height="74"
			viewBox="0 0 54 74"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M30.6752 1.99987C18.6337 19.0279 17.7704 38.1639 27.7039 40.2783C37.6375 42.3928 41.6646 29.7285 48.8959 36.5061C56.1271 43.2834 46.7805 59.2277 26.7211 50.9452C16.8258 46.8595 11.6814 50.2716 8.70992 54.0606C5.73835 57.8495 6.96922 66.1714 8.30478 69.9824M8.30478 69.9824C8.30478 69.9824 3.94972 66.8229 2.00017 65.5601M8.30478 69.9824C8.30478 69.9824 10.8481 64.6673 11.7043 63.1783"
				stroke="#0a854eff"
				stroke-width="4"
				stroke-miterlimit="16"
				stroke-linecap="round"
			/>
		</svg>
	);
}
